import clsx from "clsx";
import styles from "./style.module.scss";

export default function CreditItemSkeleton() {
  return (
    <div className={clsx(styles.cardContainer, "desktop:pb-6 animate-pulse")}>
      <div className="flex items-center justify-between pl-6 pr-4">
        <ul className="flex flex-col gap-2">
          <li className="h-4 w-16 bg-gray-300 rounded" />
          <li className="h-5 w-64 bg-gray-300 rounded" />
        </ul>
        <div className="flex gap-2">
          <div className="h-8 w-24 bg-gray-300 rounded" />
          <div className="h-8 w-24 bg-gray-300 rounded" />
        </div>
      </div>

      <ul className={clsx(styles.itemContainer, "mt-5")}>
        {[...Array(6)].map((_, index) => (
          <li key={index}>
            <span className="h-4 w-20 bg-gray-300 rounded block mb-2" />
            <span className="h-5 w-16 bg-gray-300 rounded block" />
          </li>
        ))}
      </ul>
    </div>
  );
}
